import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { HeaderSubLabel, SubColumnDef, subColumnField } from '@components/DataGrid/subColumns';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceEtaDateField = 'Trc ETA Date/Time';

/** Sub-values of the Trc ETA Date/Time column sortable via hidden companion columns */
const traceEtaDateSubColumns: SubColumnDef<DispatchLeg>[] = [{ key: 'ramp', label: 'Trc To Ramp', valueGetter: (row) => row.trcDest }];

const traceEtaDateSubLabels: HeaderSubLabel[] = traceEtaDateSubColumns.map((sub) => ({
	label: sub.label,
	field: subColumnField(traceEtaDateField, sub.key)
}));

const traceEtaDateDefinition: GridColDefExtended<DispatchLeg> = {
	field: traceEtaDateField,
	minWidth: 130,
	width: 150,
	headerName: 'Trc ETA Date/Time',
	subColumns: traceEtaDateSubColumns,
	/** Mobile cards invoke renderHeader without params (RenderCardCell), so they fall back to the
	 * static secondaryText instead of mounting the grid-subscribing sort labels per card */
	renderHeader: (params) => (
		<RenderHeader
			primaryText='Trc ETA Date/Time'
			subLabels={params.field ? traceEtaDateSubLabels : undefined}
			secondaryText='Trc To Ramp'
		/>
	),
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.traceResult && (
					<span
						className={styles.bold}
						title={row.traceETADate?.date}
					>
						{row.traceETADate?.dateTime}
					</span>
				)
			}
			secondarySlot={
				row.trcDest && (
					<span
						className={styles.bold}
						title={row.trcDest}
					>
						{row.trcDest}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { traceETADate } = row;
				return caseInsensitiveIncludes(value, traceETADate);
			});
	},
	valueGetter: (_, row: DispatchLeg) => `${row.traceETADate?.date ?? ''}|||${row.trcDest ?? ''} `,
	sortable: true,
	sortComparator: (v1, v2, cellParams1) => {
		if (typeof v1 === 'string' && typeof v2 === 'string') {
			return defaultSortComparator(v1.split('|||')[0], v2.split('|||')[0], cellParams1);
		}

		return 0;
	}
};

export default traceEtaDateDefinition;
